import { createContext, useContext } from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const NavContext = createContext(
  {}
);
const useNavContext = /* @__PURE__ */ __name(() => useContext(NavContext), "useNavContext");

export { NavContext, useNavContext };
//# sourceMappingURL=nav-context.js.map
